import { Modal } from "react-bootstrap";
import { CSSProperties } from "react";
import styled from "styled-components";

import { YoutubeContentApiResponse } from "../../../api/youtubeContentApi";
import { AffiliateApiResponse, AffiliateTypeEnum } from "../../../api/affiliateApi";

import "./style.css";

const StyledAffiliateCode = styled.div<{ $isGoods: boolean }>`
  img {
    max-width: 100%;
    height: auto;
    margin: ${({ $isGoods }) => (!$isGoods ? "0 auto" : "0")};
    display: ${({ $isGoods }) => (!$isGoods ? "block" : "0")};
  }
`;

const affiliateModal = ({
  content,
  affiliates,
}: {
  content: YoutubeContentApiResponse;
  affiliates: AffiliateApiResponse[];
}) => {
  // NOTE: React.CSSProperties で型付けしないと、flexDirection がエラーになる
  // 参考 https://qiita.com/FumioNonaka/items/b32bf5f3070dd7b3a6c9
  const getSummaryBlockStyle = ({ borderColor }: { borderColor: string }): CSSProperties => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    border: `1px solid ${borderColor}`,
    borderRadius: "8px",
    backgroundColor: "#F2EFE7",
    padding: "10px",
    minHeight: "180px",
    overflowY: "auto",
  });

  const convertHTML = ({ htmlString }: { htmlString: string }) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  const modalTitleForGoods = (
    <>
      <img src={`${process.env.PUBLIC_URL}/dumbbell.png`} style={{ width: "40px" }} />
      動画内のトレーニングに役立つ器具・グッズはコチラ💁
    </>
  );

  const serviceAffiliates = affiliates.filter(
    ({ affiliateType }) => affiliateType === AffiliateTypeEnum.SERVICE,
  );
  const randomArrayIndex = Math.floor(Math.random() * serviceAffiliates.length);

  const affiliateCode = serviceAffiliates.at(randomArrayIndex)?.affiliateCode || "";
  const affiliateSummary = serviceAffiliates.at(randomArrayIndex)?.affiliateSummary || "";

  return (
    <>
      <Modal.Header style={{ borderBottom: `5px solid ${content.category?.bgColor}` }} closeButton>
        <Modal.Title id={content.id}>
          {content.affiliate?.affiliateType === AffiliateTypeEnum.GOODS
            ? modalTitleForGoods
            : "広告"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <StyledAffiliateCode
          $isGoods={content.affiliate?.affiliateType === AffiliateTypeEnum.GOODS}
        >
          {content.affiliate?.affiliateType === AffiliateTypeEnum.GOODS
            ? convertHTML({ htmlString: content.affiliate?.affiliateCode })
            : convertHTML({ htmlString: affiliateCode })}
        </StyledAffiliateCode>
        <div
          style={getSummaryBlockStyle({ borderColor: content.category?.bgColor || "#ddd" })}
          className="mt-2"
        >
          {convertHTML({
            htmlString:
              content.affiliate?.affiliateType === AffiliateTypeEnum.GOODS
                ? content.affiliate?.affiliateSummary
                : affiliateSummary,
          })}
        </div>
      </Modal.Body>
    </>
  );
};

export default affiliateModal;
